export const URL_GENERAL_DASHBOARD_PAGE = "/";
export const URL_LOGIN_PAGE = "/login";
export const URL_DASHBOARD_PAGE = "/dynamic/Shesha.SupplierPortal/dashboard";

export const URL_RESET_PASSWORD = "/account/reset-password";
export const URL_FORGOT_PASSWORD = "/no-auth/shesha/forgot-password?mode=edit";